// PopupContent.js
//import React from "react";
import "./mockup.css";
import ReactECharts from "echarts-for-react";
import { MapContainer, TileLayer, Marker, Popup , useMap} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect,  useState } from "react";
import L from "leaflet";


 //import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { HeatmapLayer } from "react-leaflet-heatmap-layer-v3";

//import FitMapBounds from "./FitMapBounds"; // Assuming this is your helper component



delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});



// Helper component to adjust map view
const FitMapBounds = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    if (bounds.length > 0) {
      map.fitBounds(bounds);
    }
  }, [bounds, map]);
  return null;
};


const PopupContent = ({ popupData }) => {
const [showOutOfRangeOnly, setShowOutOfRangeOnly] = useState(false);

  if (!popupData) return null;

  const getTitle = () => {
    if (popupData.isStockPopup) return "Current Stock Details";
    if (popupData.isShelfPopup) {
      switch (popupData.column) {
        case "Bags under 1mth":
          return "Bags on shelves less than one month";
        case "Bags over 1mth":
          return "Bags on shelves more than one month";
        default:
          return "Distribution of bags currently on shelves";
      }
    }
    return "Cell Details";
  };

  const formatDate = (str) => {
    if (!str) return "-";
    const d = new Date(str);
    if (isNaN(d)) return "-";
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getFullYear()).slice(2)}`;
  };

  let chartContent = null;

  if (popupData.isScannedOrCollected && popupData.chartData) {
    const title = popupData.column === "Scanned" ? "Scanned" : "Collected";
    const sortedDates = Object.keys(popupData.chartData).sort((a, b) => {
      const [dayA, monthA, yearA] = a.split("/").map(Number);
      const [dayB, monthB, yearB] = b.split("/").map(Number);
      return new Date(yearA, monthA - 1, dayA) - new Date(yearB, monthB - 1, dayB);
    });

    const option = {
      title: {
        text: `${title} – ${popupData.pharmacyName}`,
        left: "center"
      },
      tooltip: {
        trigger: "axis"
      },
      xAxis: {
        type: "category",
        data: sortedDates,
        axisLabel: { rotate: 45 }
      },
      yAxis: {
        type: "value",
        name: "Count",
        minInterval: 1,
        axisLabel: {
          formatter: '{value}'
        }
      },
      series: [
        {
          name: title,
          type: "bar",
          data: sortedDates.map(date => popupData.chartData[date]),
          itemStyle: {
            color: popupData.column === "Scanned" ? "#007bff" : "#28a745"
          }
        }
      ]
    };

    chartContent = (
      <div>
        <ReactECharts option={option} style={{ height: 400 }} />
      </div>
    );
  }






  

  
if (popupData.isAccidentPopup){ //} && popupData.accidentDetails?.length) {
  return (
    <>
      <h3>Accident Book – {popupData.pharmacyName}</h3>
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <table className="popup-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Location</th>
              <th>Details</th>
              <th>Review Date</th>
            </tr>
          </thead>
          <tbody>
            {popupData.accidentDetails.map((entry, idx) => (
              <tr key={idx}>
                <td>{entry.createdAt}</td>
                <td>{entry.accidentLocation}</td>
                <td>{entry.accidentDetail}</td>
                <td>{entry.reviewDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}


  if (popupData.isWalkin && popupData.chartData) {
    const title = "Walkins";
    const sortedDates = Object.keys(popupData.chartData).sort((a, b) => {
      const [dayA, monthA, yearA] = a.split("/").map(Number);
      const [dayB, monthB, yearB] = b.split("/").map(Number);
      return new Date(yearA, monthA - 1, dayA) - new Date(yearB, monthB - 1, dayB);
    });

    const option = {
      title: {
        text: `${title} – ${popupData.pharmacyName}`,
        left: "center"
      },
      tooltip: {
        trigger: "axis"
      },
      xAxis: {
        type: "category",
        data: sortedDates,
        axisLabel: { rotate: 45 }
      },
      yAxis: {
        type: "value",
        name: "Count",
        minInterval: 1,
        axisLabel: {
          formatter: '{value}'
        }
      },
      series: [
        {
          name: title,
          type: "bar",
          data: sortedDates.map(date => popupData.chartData[date]),
          itemStyle: {
            color: "#28a745"
          }
        }
      ]
    };

    chartContent = (
      <div>
        <ReactECharts option={option} style={{ height: 400 }} />
      </div>
    );
  }


// --- %SMS by SIM stacked bar ---
// --- %SMS by SIM stacked bar ---
// --- %SMS by SIM stacked bar ---
if (popupData.isSmsBySimPopup && Array.isArray(popupData.smsBySimDetails)) {
  const rows = popupData.smsBySimDetails;

  const normalizeReason = (r) => {
    const raw = r?.simDeliveryFailReason ?? r?.reason ?? null;
    // Treat null/empty/“success”-like values as success
    if (raw == null || String(raw).trim() === "" || /success/i.test(String(raw))) {
      return "SMS sent successfully";
    }
    return String(raw);
  };

  // Tallies
  const totals = new Map(); // reason -> total
  let successWithReceipt = 0;
  let successWithoutReceipt = 0;

  for (const r of rows) {
    const reason = normalizeReason(r);

    // Aggregated form with explicit breakdown?
    if (typeof r.count === "number" && (r.withReceipt != null || r.withoutReceipt != null)) {
      totals.set(reason, (totals.get(reason) || 0) + r.count);
      if (reason === "SMS sent successfully") {
        successWithReceipt    += Number(r.withReceipt  || 0);
        successWithoutReceipt += Number(r.withoutReceipt || 0);
      }
      continue;
    }

    // Raw log (or only total)
    const inc = typeof r.count === "number" ? r.count : 1;
    totals.set(reason, (totals.get(reason) || 0) + inc);

    if (reason === "SMS sent successfully") {
      const hasReceipt = !!(r.smsDeliveryReceiptAt || r.deliveryReceiptAt);
      if (hasReceipt) successWithReceipt += inc;
      else successWithoutReceipt += inc;
    }
  }

  // If we have a success total but stacks are both zero, show that total as "without receipt"
  const successTotal = totals.get("SMS sent successfully") || 0;
  if (successTotal > 0 && successWithReceipt + successWithoutReceipt === 0) {
    successWithoutReceipt = successTotal;
  }

  const categories = Array.from(totals.keys());
  if (categories.length === 0) {
    chartContent = (
      <div style={{ padding: 16 }}>
        No SMS logs found in the selected period for {popupData.pharmacyName}.
      </div>
    );
  } else {
    // Keep “success” first on the axis
    categories.sort((a, b) =>
      a === "SMS sent successfully" ? -1 :
      b === "SMS sent successfully" ? 1  :
      a.localeCompare(b)
    );

    const isSuccess = (label) => label === "SMS sent successfully";

    const withReceiptSeries    = categories.map(c => isSuccess(c) ? successWithReceipt    : 0);
    const withoutReceiptSeries = categories.map(c => isSuccess(c) ? successWithoutReceipt : 0);
    const otherTotalsSeries    = categories.map(c => isSuccess(c) ? 0 : (totals.get(c) || 0));

    const option = {
      title: { text: `%SMS by SIM – ${popupData.pharmacyName}`, left: "center" },
      legend: { top: 24 },
      grid: { top: 72, left: 50, right: 30, bottom: 90, containLabel: true },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (params) => {
          const total = params.reduce((s, p) => s + (Number(p.value) || 0), 0);
          const lines = params.map(p => `${p.marker} ${p.seriesName}: ${p.value}`);
          return `${params[0].axisValue}<br/>${lines.join("<br/>")}<br/><b>Total: ${total}</b>`;
        }
      },
      xAxis: {
        type: "category",
        data: categories,
        axisLabel: {
          rotate: 60,
          margin: 28,
          hideOverlap: true
        }
      },
      yAxis: { type: "value", name: "Count", minInterval: 1 },
      series: [
        { name: "Other totals",          type: "bar", data: otherTotalsSeries },
        { name: "Sent without receipt",  type: "bar", data: withoutReceiptSeries, stack: "success" },
        { name: "With delivery receipt", type: "bar", data: withReceiptSeries,    stack: "success" }
      ]
    };

    chartContent = <ReactECharts option={option} style={{ height: 500, width: "100%" }} />;
  }
}






  if (popupData.column === "Near Miss" && popupData.nearMissDetails?.length) {
    const totalDays = popupData.nearMissDetails[0]?.totalDays || 0;
    const totalEntries = popupData.nearMissDetails[0]?.totalEntries || 0;

    const breakdown = popupData.nearMissDetails.map(item => ({
      name: item.errorTypeId,
      count: item.count,
      percent: ((item.count / totalEntries) * 100).toFixed(1)
    }));

    const option = {
      title: {
        text: `Near Misses – ${popupData.pharmacyName}`,
        left: "center"
      },
      tooltip: {
        trigger: "item",
        formatter: (params) => `${params.name}: ${params.value} episodes<br/>${params.percent}%`
      },
      legend: {
        show: false
      },
      series: [
        {
          name: "Error Type",
          type: "pie",
          radius: "50%",
          data: breakdown.map(item => ({
            name: item.name,
            value: item.count
          })),
          label: {
            show: true,
            formatter: "{b}",
            fontSize: 12
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }
      ]
    };

    chartContent = (
      <>
        <ReactECharts option={option} style={{ height: 400 }} />
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <strong>Total:</strong> {totalEntries} near misses over {totalDays} days
        </div>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          {breakdown.map((item, idx) => (
            <div key={idx}>
              {item.name}: {item.count} episodes ({item.percent}%)
            </div>
          ))}
        </div>
      </>
    );
  }

  if (chartContent) {
    return (
      <div className="popup-content">
        <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
        {chartContent}
      </div>
    );
  }

  if (popupData.isShelfPopup) {
    return (
      <div className="popup-content">
        <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
        <h3>{getTitle()}</h3>
        <p><strong>Pharmacy Name:</strong> {popupData.pharmacyName}</p>
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          <table className="popup-table">
            <thead>
              <tr>
                <th className="shelf-col">Shelf</th>
                <th className="count-col">Bag Count</th>
              </tr>
            </thead>
            <tbody>
              {popupData.shelfDetails?.length ? (
                popupData.shelfDetails.map((entry, idx) => (
                  <tr key={idx}>
                    <td className="shelf-col">{entry.description}</td>
                    <td className="count-col">{entry.count}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="2">No data available</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

if (popupData.isDeliveryPopup) {
  const points = popupData.deliveryDetails?.points ?? [];
  const safeCoords = points.map(coordWrapper =>
    Array.isArray(coordWrapper[0]) ? coordWrapper[0] : coordWrapper
  );

  const hasPoints = safeCoords.length > 0;
  const mapCenter = hasPoints ? [52.5, -1.9] : [20, 0];
  const mapZoom = hasPoints ? 11 : 2;

  return (
    <div className="popup-content">
      <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
      <h3>Deliveries – {popupData.pharmacyName}</h3>

      <div style={{ display: "flex", gap: "10px" }}>
        {/* 📍 Left: Pin Map */}
        <MapContainer
          center={mapCenter}
          zoom={mapZoom}
          style={{ height: "300px", width: "50%" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {hasPoints &&
            safeCoords.map(([lat, lng], idx) => (
              <Marker key={idx} position={[lat, lng]}>
                <Popup>Delivery #{idx + 1}</Popup>
              </Marker>
            ))}
          {hasPoints && <FitMapBounds bounds={safeCoords} />}
        </MapContainer>

        {/* 🔥 Right: Heatmap */}
        <MapContainer
          center={mapCenter}
          zoom={mapZoom}
          style={{ height: "300px", width: "50%" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {hasPoints && (
            <HeatmapLayer
              fitBoundsOnLoad
              fitBoundsOnUpdate
              points={safeCoords.map(([lat, lng]) => ({ lat, lng }))}
              longitudeExtractor={m => m.lng}
              latitudeExtractor={m => m.lat}
              intensityExtractor={() => 1}
            />
          )}
          {hasPoints && <FitMapBounds bounds={safeCoords} />}
        </MapContainer>
      </div>

      <p>Deliveries: {popupData.deliveryDetails?.count ?? 0}</p>
    </div>
  );
}



if (popupData.isShelfCheckPopup) { //} && popupData.shelfcheckdetails?.length) {
  const formatDate = (str) => {
    if (!str) return "-";
    const d = new Date(str);
    return isNaN(d)
      ? "-"
      : `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getFullYear()).slice(2)}`;
  };

  return (
    <div className="popup-content">
      <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
      <h3>Shelf Check Details – {popupData.pharmacyName}</h3>
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <table className="popup-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Interval (days)</th>
              <th>Next Due</th>
            </tr>
          </thead>
          <tbody>
            {popupData.shelfcheckdetails.map((entry, idx) => (
              <tr key={idx}>
                <td>{entry.description}</td>
                <td>{entry.interval ?? "-"}</td>
                <td>{formatDate(entry.nextdue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


  if (popupData.isStockPopup) {
    return (
      <>
        <h3>{getTitle()}</h3>
        <p><strong>Pharmacy Name:</strong> {popupData.pharmacyName}</p>
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          <table className="popup-table">
            <thead>
              <tr>
                <th className="drug-col">Drug</th>
                <th className="location-col">Location</th>
                <th className="exp-col">Expiry</th>
                <th className="scan-col">Scanned</th>
              </tr>
            </thead>
            <tbody>
              {popupData.stockDetails?.length ? (
                popupData.stockDetails.map((entry, idx) => (
                  <tr key={idx}>
                    <td className="drug-col">{entry.vmppNm}</td>
                    <td className="location-col">{entry.location || "-"}</td>
                    <td className="exp-col">{formatDate(entry.expiryDate)}</td>
                    <td className="scan-col">{formatDate(entry.firstScanned)}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="4">No stock data available</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  }


if (popupData.isHandoverPopup && popupData.handoverDetails?.length) {
  return (
    <>
      <h3>Outstanding Handover Items – {popupData.pharmacyName}</h3>
      <table className="popup-table">
        <thead><tr><th>Created</th><th>Topic</th><th>Description</th></tr></thead>
        <tbody>
          {popupData.handoverDetails.map((item, idx) => (
            <tr key={idx}><td>{item.createdAt}</td><td>{item.topic}</td><td>{item.description}</td></tr>
          ))}
        </tbody>
      </table>
    </>
  );
}




if (popupData.isCleaningPopup ){ //&& popupData.cleaningDetails?.length) {
  return (
    <div className="popup-content">
      <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
      <h3>Cleaning Log – {popupData.pharmacyName}</h3>
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <table className="popup-table">
          <thead>
            <tr>
              <th>Area</th>
              <th>Next due</th>
            </tr>
          </thead>
          <tbody>
            {popupData.cleaningDetails.map((entry, idx) => (
              <tr key={idx}>
                <td>{entry.areaName}</td>
                <td>{entry.nextDue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


if (popupData.column === "Fridge" && popupData.fridgeLogs?.length) {
  const logs = popupData.fridgeLogs;

  const grouped = {};
  logs.forEach(log => {
    const name = log.fridgeName;
    if (!grouped[name]) grouped[name] = [];
    grouped[name].push({
      date: log.createdAt,
      min: parseFloat(log.minTemperature),
      max: parseFloat(log.maxTemperature),
      median: (parseFloat(log.minTemperature) + parseFloat(log.maxTemperature)) / 2
    });
  });

  return (
    <div
      className="popup-content"
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        maxWidth: "100%",
        maxHeight: "90vh",
        overflowX: "hidden",
        boxSizing: "border-box"
      }}
    >
      <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>

      <div
        style={{
          flex: 0.6,
          minWidth: 0,
          overflowY: "auto",
          paddingRight: "12px"
        }}
      >
        {Object.entries(grouped).map(([fridgeName, entries]) => {
          const sortedEntries = [...entries].sort((a, b) => new Date(b.date) - new Date(a.date));
          const dates = sortedEntries.map(e => e.date);
          const minTemp = Math.min(...sortedEntries.map(e => e.min));
          const maxTemp = Math.max(...sortedEntries.map(e => e.max));
          const yMin = Math.floor(minTemp * 0.9);
          const yMax = Math.max(9, Math.ceil(maxTemp * 1.2));

          const candleData = sortedEntries.map(e => [
            e.min + 0.01,
            e.max - 0.01,
            e.min,
            e.max
          ]);

          const medianData = sortedEntries.map(e => e.median);

          const option = {
            title: {
              text: `Fridge: ${fridgeName} – ${popupData.pharmacyName}`,
              left: "center",
              textStyle: { fontSize: 12 }
            },
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                const point = params[0];
                const date = point.axisValue;
                const entry = sortedEntries.find(e => e.date === date);
                if (!entry) {
                  return `<strong>${fridgeName}</strong><br/>Date: ${date}<br/>No data`;
                }
                const { min, max, median } = entry;
                return `
                  <strong>${fridgeName}</strong><br/>
                  Date: ${date}<br/>
                  Min: ${min}°C<br/>
                  Max: ${max}°C<br/>
                  Median: ${median?.toFixed(1) ?? "n/a"}°C
                `;
              }
            },
            xAxis: {
              type: "category",
              data: dates,
              axisLabel: { rotate: 45, fontSize: 10 },
              name: "Time",
              nameTextStyle: { fontSize: 10 }
            },
            yAxis: {
              type: "value",
              name: "°C",
              min: yMin,
              max: yMax,
              axisLabel: { fontSize: 10 },
              nameTextStyle: { fontSize: 10 }
            },
            grid: {
              top: 50,
              left: 35,
              right: 20,
              bottom: 50
            },
            series: [
              {
                name: "Temperature Range",
                type: "candlestick",
                data: candleData,
                itemStyle: {
                  color: "#a0c4ff",
                  borderColor: "#1d4ed8",
                  borderWidth: 1
                },
                barWidth: 2,
                markLine: {
                  silent: true,
                  symbol: "none",
                  lineStyle: {
                    color: "darkred",
                    width: 2,
                    type: "solid"
                  },
                  data: [{ yAxis: 2 }, { yAxis: 8 }]
                }
              },
              {
                name: "Median",
                type: "line",
                data: medianData,
                lineStyle: {
                  color: "#ef4444",
                  width: 1.5
                },
                symbol: "circle",
                symbolSize: 3,
                showSymbol: false,
                markLine: {
                  silent: true,
                  symbol: "none",
                  lineStyle: {
                    color: "darkred",
                    width: 2,
                    type: "solid"
                  },
                  data: [{ yAxis: 2 }, { yAxis: 8 }]
                }
              }
            ]
          };

          return (
            <div key={fridgeName} style={{ marginBottom: "20px" }}>
              <ReactECharts option={option} style={{ height: 260 }} />
            </div>
          );
        })}
      </div>

      <div
        style={{
          flex: 0.4,
          minWidth: 0,
          overflowY: "auto",
          maxHeight: "80vh",
          borderLeft: "1px solid #ccc",
          paddingLeft: "10px"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: "10px"
          }}
        >
          <label style={{ fontSize: "0.85rem", display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={showOutOfRangeOnly}
              onChange={(e) => setShowOutOfRangeOnly(e.target.checked)}
              style={{ marginRight: "6px" }}
            />
            Only out of range
          </label>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "14ch 20ch 8ch 8ch",
            fontWeight: "bold",
            borderBottom: "1px solid #ccc",
            paddingBottom: "6px",
            marginBottom: "6px",
            fontSize: "0.85rem",
            width: "100%",
            overflowX: "hidden"
          }}
        >
          <div>Date</div>
          <div style={{ transform: "translateX(-1ch)" }}>Fridge</div>
          <div style={{ transform: "translateX(-3ch)" }}>Min</div>
          <div style={{ transform: "translateX(-3ch)" }}>Max</div>
        </div>

        {logs
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .map((log, idx) => {
            const min = parseFloat(log.minTemperature);
            const max = parseFloat(log.maxTemperature);
            const outOfRange = min < 2 || max > 8;

            if (showOutOfRangeOnly && !outOfRange) return null;

            return (
              <div
                key={idx}
                style={{
                  display: "grid",
                  gridTemplateColumns: "14ch 20ch 8ch 8ch",
                  background: outOfRange ? "coral" : "#f0f0f0",
                  padding: "6px 0",
                  borderRadius: "4px",
                  marginBottom: "4px",
                  fontSize: "0.85rem",
                  width: "100%",
                  overflowX: "hidden"
                }}
              >
                <div>{log.createdAt}</div>
                <div
                  title={log.fridgeName}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "20ch"
                  }}
                >
                  {log.fridgeName}
                </div>
                <div>{min.toFixed(1)}°C</div>
                <div>{max.toFixed(1)}°C</div>
              </div>
            );
          })}
      </div>
    </div>
  );
}


  if (popupData.column === "Accidents" && popupData.accidentDetails?.length) {
    return (
      <div className="popup-content">
        <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
        <h3>Accident Book – {popupData.pharmacyName}</h3>
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          <table className="popup-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Location</th>
                <th>Details</th>
                <th>Review Date</th>
              </tr>
            </thead>
            <tbody>
              {popupData.accidentDetails.map((entry, idx) => (
                <tr key={idx}>
                  <td>{entry.createdAt}</td>
                  <td>{entry.accidentLocation}</td>
                  <td>{entry.accidentDetail}</td>
                  <td>{entry.reviewDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (popupData.isStockPopup && popupData.stockDetails?.length) {
    return (
      <div className="popup-content">
        <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
        <h3>{getTitle()}</h3>
        <p><strong>Pharmacy Name:</strong> {popupData.pharmacyName}</p>
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          <table className="popup-table">
            <thead>
              <tr>
                <th className="drug-col">Drug</th>
                <th className="location-col">Location</th>
                <th className="exp-col">Expiry</th>
                <th className="scan-col">Scanned</th>
              </tr>
            </thead>
            <tbody>
              {popupData.stockDetails.map((entry, idx) => (
                <tr key={idx}>
                  <td className="drug-col">{entry.vmppNm}</td>
                  <td className="location-col">{entry.location || "-"}</td>
                  <td className="exp-col">{formatDate(entry.expiryDate)}</td>
                  <td className="scan-col">{formatDate(entry.firstScanned)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="popup-content">
      <button className="popup-close" onClick={() => popupData.onClose?.()}>X</button>
      <h3>Cell Details</h3>
      <p><strong>Pharmacy Name:</strong> {popupData.pharmacyName}</p>
      <p><strong>Type:</strong> {popupData.column}</p>
    </div>
  );
};

export default PopupContent;
